import { defineMessages } from "react-intl";
import { defaultListMessages, ListMessages } from "../shared/crud/list";
import { loyaltyTagCommonMessages } from "./common.messages";

export const loyaltyTagSectionsListMessages: ListMessages = {
  ...defaultListMessages,
  entityName: {
    id: "loyaltyTagSections.title",
    defaultMessage: "Preferences management",
  },
  tableHeaders: {
    ticker: {
      id: "loyaltyTagSections.table.ticker",
      defaultMessage: "Id",
    },
    name: {
      id: "loyaltyTagSections.table.name",
      defaultMessage: "Name",
    },
    tags: {
      id: "loyaltyTagSections.table.preferences",
      defaultMessage: "Preferences",
    },
    order: {
      id: "loyaltyTagSections.table.order",
      defaultMessage: "Order",
    },
  },
};

export const loyaltyTagSectionsMessages = defineMessages({
  createSection: {
    id: "loyaltyTagSections.createSection",
    defaultMessage: "Create section",
  },
  preferencesManagement: {
    id: "loyaltyTagSections.preferencesManagement",
    defaultMessage: "Loyalty preferences management",
  },
  edit: loyaltyTagCommonMessages.edit,
});
